<template>
  <div v-if="activeModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="closeModal">
    <div class="bg-white rounded-lg w-full max-w-6xl shadow-lg flex flex-col relative mx-4 max-h-[90vh]">
      <!-- Modal Header -->
      <div class="flex items-center justify-end px-6 py-4">
        <button type="button" class="text-gray-400 hover:text-gray-600 transition" @click="closeModal">
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <!-- Modal Body -->
      <div class="flex-1 overflow-hidden">
        <!-- Loader -->
        <div v-if="loader" class="flex items-center justify-center">
          <div class="text-center">
            <img
              src="@/assets/imgs/tuin_loader_v2.gif"
              alt="cargando..."
              class="w-[500px] mx-auto"
            />
          </div>
        </div>
        
        <!-- Contenido del modal -->
        <div v-else class="px-6 h-full overflow-y-auto">         
          <!-- Estado vacío cuando no hay leads -->
          <div 
            v-if="Leads.length === 0 && tab == 'list'"
            class="flex flex-col items-center justify-center text-center py-16"
          >
            <div class="flex items-center justify-center mb-6">
              <img class="h-[140px]" src="@/assets/imgs/undraw_people_ka7y2.svg" alt="">
            </div>
            <p class="text-gray-900 text-base sm:text-lg font-normal max-w-md">
              No tienes prospectos agregados, te invitamos a que agregues a tus prospectos
            </p>
            <button 
              class="flex mt-6 rounded-lg bg-tuin-100 hover:bg-tuin_hover px-5 py-2.5 text-sm text-white font-medium transition-colors"
              @click="changeTab"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9.5H14C14.2652 9.5 14.5196 9.60536 14.7071 9.79289C14.8946 9.98043 15 10.2348 15 10.5C15 10.7652 14.8946 11.0196 14.7071 11.2071C14.5196 11.3946 14.2652 11.5 14 11.5H11V14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73478 15.5 9.48043 15.3946 9.29289 15.2071C9.10536 15.0196 9 14.7652 9 14.5V11.5H6C5.73478 11.5 5.48043 11.3946 5.29289 11.2071C5.10536 11.0196 5 10.7652 5 10.5C5 10.2348 5.10536 9.98043 5.29289 9.79289C5.48043 9.60536 5.73478 9.5 6 9.5H9V6.5C9 6.23478 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5Z" fill="white"/>
              </svg>
              <span class="ml-2">Agregar nuevo prospecto</span>
            </button>
          </div>
          
          <!-- Tabla cuando hay leads -->
          <div 
            v-else-if="Leads.length > 0 && tab == 'list'"
            class="w-full"
          >
            <TableLeadPropertyComponent 
              :list="Leads" 
              :property-id="props.propertyId" 
              :current-page="currentPage"
              :total-pages="totalPages"
              @add-prospect="changeTab"
              @change-page="handlePageChange"
            />
          </div>

          <!-- Formulario -->
          <div 
            v-if="tab == 'form'"
            class="w-full"
          >
            <FormLeadPropertyComponent 
              @trigger-update-lead="updateListLead" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, computed } from "vue";
import axios from "axios";

import { useStore } from "vuex";
const store = useStore();
let session = computed(() => store.getters.getUserSession);

import { useRouter } from "vue-router";
import TableLeadPropertyComponent from "@/components/leads/TableLeadPropertyComponent.vue";
import FormLeadPropertyComponent from "@/components/leads/FormLeadPropertyComponent.vue";
// import LeadFormView from "@/components/leads/LeadFormView.vue";

let router = useRouter();

const emit = defineEmits(["triggerUpdate"]);

const props = defineProps({
  propertyId: {
    type: Number,
    required: true,
    default: null,
  },
  showModal: {
    type: Boolean,
    required: true,
    default: false,
  },
});

let activeModal = ref(false);
let loader = ref(true);
let Leads = ref([]);
let tab = ref('list');
let currentPage = ref(1);
let totalPages = ref(1);

function closeModal() {
  emit("triggerUpdate");
}

async function getListLeads() {
  loader.value = true;
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/properties/${props.propertyId}?page=${currentPage.value}`;

  var options = {
    headers: {
      "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
      Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
    },
  };
  try {
    const response = await axios.get(url_cnn, options);
    if (response.status == 200) {
      Leads.value = response.data.resp;
      let pages = response.data.pages;
      currentPage.value = pages.current_page;
      totalPages.value = pages.last_page;
      //scrollToTop();

    }
    loader.value = false;
  } catch (error) {
    console.error("ERROR", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
    loader.value = false;
  }
}

function changeTab(){
  tab.value = tab.value == 'list'? 'form':'list';
}

async function handlePageChange(page) {
  currentPage.value = page;
  getListLeads();
}

async function updateListLead(){
  await getListLeads();
  await changeTab();
}

watch(
  () => props,
  async (newVal) => {
    activeModal.value = newVal && newVal.showModal;

    if (activeModal.value) {
      getListLeads();
    }
  },
  { immediate: true }
);
</script>
